/*
The API key for your Amplitude project is required. Optionally, a user ID and config object can be passed in this call.
The SDK can be used anywhere after it is initialized anywhere in an application.
*/

import { init, add } from '@amplitude/analytics-browser';
import { removeQueryParameter } from 'utils/urlSearchParams';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import * as amplitude from '@amplitude/analytics-browser';
import { useTranslation } from 'react-i18next';

const getDeviceId = () => {
  const storedDeviceId = sessionStorage.getItem('amplitudeDeviceId');
  if (storedDeviceId !== null) {
    return storedDeviceId;
  }
  const deviceId = new URLSearchParams(window.location.search).get('deviceId');
  if (deviceId === null) {
    return undefined;
  }
  sessionStorage.setItem('amplitudeDeviceId', deviceId);
  removeQueryParameter('deviceId');
  return deviceId;
};

const addSessionReplay = () => {
  if (process.env.REACT_APP_ENV === 'prod' || process.env.REACT_APP_ENV === 'uat') {
    const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1 });
    add(sessionReplayTracking);
  }
};

const initAmplitude = async (showAmplitudeSurvey: boolean, currentLocale?: string) => {
  if (process.env.REACT_APP_AMPLITUDE_API_KEY) {
    const data = init(`${process.env.REACT_APP_AMPLITUDE_API_KEY}`, undefined, {
      deviceId: getDeviceId(),
      defaultTracking: {
        pageViews: true,
        sessions: true,
      },
    });
    if (showAmplitudeSurvey) {
      add(engagementPlugin({ locale: currentLocale }));
    }
    addSessionReplay();
    return data;
  }
  return false;
};

export { initAmplitude };
